module.exports = __webpack_public_path__ + "img/spiadi.1ec256cf.jpg";